import { compareAsc } from 'date-fns';

/**
 * Sorts options by label in alphabetical order (case-insensitive)
 * @param a - First option with label property
 * @param b - Second option with label property
 * @returns -1 if a < b, 1 if a > b, 0 if equal
 */
export const sortOptionsByLabel = <T extends { label: string }>(
  a: T,
  b: T
): number => {
  const labelA = a.label.toUpperCase();
  const labelB = b.label.toUpperCase();
  if (labelA < labelB) return -1;
  if (labelA > labelB) return 1;
  return 0;
};

/**
 * Comparator that orders items chronologically (oldest first) by their
 * `created` timestamp. Works with ISO date strings.
 */
export const sortByCreatedAsc = <T extends { created: string }>(
  a: T,
  b: T
): number => compareAsc(new Date(a.created), new Date(b.created));
